/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServizioMensaDTO } from './servizio-mensa-dto';
import { TipologiaPratica } from './tipologia-pratica';


export interface ServizioDTO { 
    id?: string;
    tipo_pratica_id?: string;
    tipo_pratica_codice?: string;
    tipo_pratica_titolo?: string;
    tipologia_pratica?: TipologiaPratica;
    tipo_servizio?: ServizioDTOTipoServizioEnum;
    data_inizio?: string;
    data_fine?: string;
    version?: number;
    created_at?: string;
    updated_at?: string;
    mensa?: ServizioMensaDTO;
}
export enum ServizioDTOTipoServizioEnum {
    MENSA = 'MENSA'
};



